import { Route, Routes } from 'react-router-dom';
import { Suspense, lazy } from 'react';

import { Loading } from '../components';
import { publicUrlStr } from '../utils';
import * as S from './style';

const Video = lazy(() => import('../pages/Video'));
const Image = lazy(() => import('../pages/Image'));
const Audio = lazy(() => import('../pages/Audio'));
const Search = lazy(() => import('../pages/Search'));
const Admin = lazy(() => import('../pages/Admin'));

function RouterSwitch() {

  const mainUrl = publicUrlStr(); //base path

  return (
    <S.Wrapper>
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* Video Routes */}
          <Route path={mainUrl} element={<Video />} />
          <Route path={`${mainUrl}/video`} element={<Video />} />
          <Route path={`${mainUrl}/video/:videoId`} element={<Video />} />

          {/* Image Routes */}
          <Route path={`${mainUrl}/image`} element={<Image />} />
          <Route path={`${mainUrl}/image/:imageId`} element={<Image />} />

          {/* Audio Routes */}
          <Route path={`${mainUrl}/audio`} element={<Audio />} />
          <Route path={`${mainUrl}/audio/:audioId`} element={<Audio />} />
          <Route path={`${mainUrl}/search`} element={<Search />} />

          {/* Admin Routes */}
          <Route path={`${mainUrl}/admin`} element={<Admin />} />

        </Routes>
      </Suspense>
    </S.Wrapper>
  )
}

export default RouterSwitch;
